import theme from '@/style';
import React from 'react';
import {View, StyleSheet} from 'react-native';
import Text from '@/components/basic/text';
import DigitBall from '../../components/digit-ball';

const ResultItem = ({
  index = 0,
  issueNum,
  time,
  result,
  isQuick: _isQuick = false,
  emptyType = '*',
}: {
  index?: number;
  result?: string;
  issueNum?: string;
  time?: string;
  isQuick?: boolean;
  emptyType?: string;
}) => {
  const backgroundColor = React.useMemo(() => {
    return index % 2 === 0 ? styles.whiteRow : styles.grayRow;
  }, [index]);

  const displayTime = React.useMemo(() => {
    if (!time) {
      return '';
    }
    return time
      .replace(/(\d{1,2}:\d{2}):\d{2}(?=\s*[AP]M)/i, '$1')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  }, [time]);

  const resultDigit = React.useMemo(() => {
    if (result) {
      return result.split('');
    }
    return new Array(3).fill(emptyType);
  }, [result, emptyType]);

  return (
    <View style={[styles.itemContainer, backgroundColor]}>
      <View style={styles.issueCol}>
        <Text accent fontSize={12} numberOfLines={1} style={styles.issueText}>
          {issueNum}
        </Text>
      </View>
      <View style={styles.timeCol}>
        <Text accent fontSize={12} textAlign="center" numberOfLines={1}>
          {displayTime}
        </Text>
      </View>
      <View style={styles.resultCol}>
        {['A', 'B', 'C'].map((item, _i) => (
          <DigitBall
            ballSize={24}
            digit={resultDigit[_i]}
            emptyType={emptyType}
            color={item}
            key={_i}
          />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  itemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 12,
    paddingHorizontal: 12,
    marginHorizontal: 12,
  },
  whiteRow: {
    backgroundColor: theme.basicColor.white,
  },
  grayRow: {
    backgroundColor: '#F8F9FF',
  },
  issueCol: {
    width: 102,
  },
  issueText: {
    lineHeight: 16,
  },
  timeCol: {
    width: 80,
    alignItems: 'center',
  },
  resultCol: {
    width: 80,
    flexDirection: 'row',
    gap: 4,
  },
});

export default ResultItem;
